import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CancelReleaseOrder} from '../models/cancel-release-order';
import {BackendListModel} from '../models/common/list.model';
import {ContainerPickup} from '../models/container-pickup';
import {Containerdropoff} from '../models/containerdropoff';
import {ContainerModel} from '../models/container_master_model/container-model';
import {LocationModel} from '../models/container_master_model/location';
import {ManHourCharge} from '../models/Depot_Master_Model/man-hour-charge';
import {DoContact} from '../models/do-contact';
import {ContainerInfo, DoContainerReference} from '../models/do-container-reference';
import {ExternalDoRevalidation} from '../models/external-do-revalidation';
import {ReleaseOrder} from '../models/release-order';
import {ReturnContactInfo} from '../models/return-contact-info';
import {ReturnContainer} from '../models/return-container';
import {ReturnContainerReference} from '../models/return-container-reference';
import {RevalidateReleaseOrder} from '../models/revalidate-release-order';
import {ApiRoutes} from './apiroutes';
import {CancelReturnOrder} from '../models/cancel-return-order';
import {RevalidateReturnOrder} from '../models/revalidate-return-order';
import {ContainersList} from '../models/return-container-reference';

@Injectable({
    providedIn: 'root'
})
export class ReleaseOrderService {
    base_url = ApiRoutes.Booking;
    base_url1 = ApiRoutes.ContainerMaster;
    base_url2 = ApiRoutes.Location;
    base_url3 = ApiRoutes.DepotMaster
    base_url4 = ApiRoutes.LeadRequest;
    selectedOrder: ReleaseOrder;
    selectedROrder: ReturnContainer;
    save_pickup_url = `${this.base_url}mark_closed_do_container_pickup/`;
    pickupData:any;
    // isShowRejectBooking: boolean = true;
    constructor(private http: HttpClient) {
    }

    //Post and Update Release Order
    postReleaseOrder(release: ReleaseOrder): Observable<any> {
        let url = `${this.base_url}do_details/`;
        return this.http.post(url, release);
    }

    postValidateContainer(release: any): Observable<any> {
        let url = `${this.base_url}do_details/?only_validate=true`;
        return this.http.post(url, release);
    }

    updateReleaseOrder(data: ReleaseOrder): Observable<any> {
        let url = `${this.base_url}do_details/${data.id}/`;
        return this.http.put(url, data);
    }

    //Get Release Order by RequestID
    getReleaseOrderbyRequestId(reqId): Observable<BackendListModel<ReleaseOrder>> {
        let url = `${this.base_url}do_details_request/${reqId}/`;
        return this.http.get<BackendListModel<ReleaseOrder>>(url);
    }

    //Cancel Release Order
    cancelReleaseorder(data: CancelReleaseOrder) {
        let url = `${this.base_url}do_cancellation/`;
        return this.http.post(url, data);
    }

    //Post Contact Details
    postDOContact(data: DoContact) {
        let url = `${this.base_url}do_contact_information/`;
        return this.http.post(url, data);
    }

    updateDOContact(data: DoContact) {
        let url = `${this.base_url}do_contact_information/${data.id}/`;
        return this.http.put(url, data);
    }

    //Post & Update Revallidation release Order
    postRevalidateReleaseOrder(data: RevalidateReleaseOrder) {
        let url = `${this.base_url}do_revalidation/`;
        return this.http.post(url, data);
    }

    updateRevalidateReleaseOrder(data: RevalidateReleaseOrder) {
        let url = `${this.base_url}do_revalidation/${data.id}/`;
        return this.http.put(url, data);
    }

    //Do Container Reference
    getDOcontainerReference(): Observable<BackendListModel<DoContainerReference>> {
        let url = `${this.base_url}do_container_reference/`;
        return this.http.get<BackendListModel<DoContainerReference>>(url);
    }

    getAllPickupContainers(reqID): Observable<BackendListModel<ContainerPickup>> {
        let url = `${this.base_url}do_container_pickup/?request_id=${reqID}`;
        return this.http.get<BackendListModel<ContainerPickup>>(url);
    }

    getAllPickupContainers1(reqID, page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ContainerPickup>> {
        let url = `${this.base_url}do_container_reference/?request_id=${reqID}`;
        let urlObj = new URL(url);
        // urlObj.searchParams.append('reqID', String(reqID));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('search', String(search));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<ContainerPickup>>(String(urlObj));
    }

    postDOcontainerReference(data: DoContainerReference) {
        let url = `${this.base_url}do_container_reference/`;
        return this.http.post(url, data);
    }

    postDOContainerPickup(data: ContainerPickup) {
        let url = `${this.base_url}do_container_pickup/?only_validate=true`;
        return this.http.post<ContainerInfo[]>(url, data);
    }

    saveContainerPickup(data: ContainerPickup) {
        let url = `${this.base_url}do_container_pickup/`;
        return this.http.post<ContainerInfo[]>(url, data, {observe: 'response'});
    }

    // updateDOContainerPickup(data:ContainerPickup){
    //   let url = `${this.base_url}do_container_pickup/${data.id}`;
    //   return this.http.put(url,data);
    // }

    getContainerPickupbyreqID(ReqId): Observable<BackendListModel<ContainerPickup>> {
        let url = `${this.base_url}do_container_pickup/?request_id=${ReqId}`;
        return this.http.get<BackendListModel<ContainerPickup>>(url);
    }

    postDOContainerReference(data: DoContainerReference, id) {
        let url = `${this.base_url}do_container_reference/${id}/`;
        return this.http.put(url, data);
    }

    updateDOContainerReference(data: DoContainerReference) {
        let url = `${this.base_url}do_container_reference/${data.id}/`;
        return this.http.put(url, data);
    }

    deleteDOContainerReference(data) {
        let url = `${this.base_url}do_container_reference/${data.id}/`;
        return this.http.delete(url);
    }

    // getAllContainersbyDoId(DoId): Observable<BackendListModel<ContainerModel>> {
    //   let url = `${this.base_url1}container_number?do_id=${DoId}`;
    //   return this.http.get<BackendListModel<ContainerModel>>(url);
    // }

    getAllContainersbyDoId(DoId, page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ContainerModel>> {
        let url = `${this.base_url1}container_number/?do_id=${DoId}`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('search', String(search));
        urlObj.searchParams.append('o', String(order));
        return this.http.get<BackendListModel<ContainerModel>>(String(urlObj));
    }

    //Return Container Details API
    getReturnDetailsbyRequestId(reqId): Observable<BackendListModel<ReturnContainer>> {
        let url = `${this.base_url}return_details_request/${reqId}/`;
        return this.http.get<BackendListModel<ReturnContainer>>(url);
    }

    postReturnDetails(returnContainer: ReturnContainer): Observable<any> {
        let url = `${this.base_url}return_details/`;
        return this.http.post(url, returnContainer);
    }

    updateReturnDetails(returnContainer: ReturnContainer): Observable<any> {
        let url = `${this.base_url}return_details/${returnContainer.id}/`;
        return this.http.put(url, returnContainer);
    }

    cancelReturnorder(data: CancelReturnOrder) {
        let url = `${this.base_url}return_cancellation/`;
        return this.http.post(url, data);
    }

    //Post & Update Revallidation release Order
    postRevalidateReturnOrder(data: RevalidateReturnOrder) {
        let url = `${this.base_url}return_revalidation/`;
        return this.http.post(url, data);
    }

    updateRevalidateReturnOrder(data: RevalidateReturnOrder) {
        let url = `${this.base_url}return_revalidation/${data.id}/`;
        return this.http.put(url, data);
    }

    postReturnContactInfo(returnContact: ReturnContactInfo) {
        let url = `${this.base_url}return_contact_information/`;
        return this.http.post(url, returnContact);
    }

    updateReturnContactInfo(returnContact: ReturnContactInfo) {
        let url = `${this.base_url}return_contact_information/${returnContact.id}/`;
        return this.http.put(url, returnContact);
    }

    getReturnContainerReference(): Observable<BackendListModel<ReturnContainerReference>> {
        let url = `${this.base_url}return_container_reference/`;
        return this.http.get<BackendListModel<ReturnContainerReference>>(url);
    }

    postReturnContainerReference(returnConReference: ReturnContainerReference) {
        let url = `${this.base_url}return_container_reference/`;
        return this.http.post(url, returnConReference);
    }

    deleteReturnContainerReference(data) {
        let url = `${this.base_url}return_container_reference/${data.id}/`;
        return this.http.delete(url);
    }

    updateReturnContainerReference(returnConReference: ReturnContainerReference) {
        let url = `${this.base_url}return_container_reference/${returnConReference.id}/`;
        return this.http.put(url, returnConReference);
    }

    postReturnContainerDropOff(data: Containerdropoff) {
        console.log('postReturnContainerDropOff return_container_dropoff/')
        let url = `${this.base_url}return_container_dropoff/`;
        return this.http.post(url, data);
    }

    getReturnContainerPickupbyDoId(ReqId): Observable<BackendListModel<Containerdropoff>> {
        let url = `${this.base_url}return_container_dropoff?return_id=${ReqId}`;
        return this.http.get<BackendListModel<Containerdropoff>>(url);
    }

    getAllDropoffContainers(reqID, page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<Containerdropoff>> {
        let url = `${this.base_url}return_container_dropoff/?request_id=${reqID}`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('search', String(search));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<Containerdropoff>>(String(urlObj));
    }

    postReturnDropoffbyReqid(data: DoContainerReference, refID) {
        let url = `${this.base_url}return_container_reference_rud/${refID}/`;
        return this.http.put(url, data);
    }

    updateReturnDropoffbyReqid(data: DoContainerReference) {
        let url = `${this.base_url}return_container_reference_rud/${data.id}/`;
        return this.http.put(url, data);
    }

    //External DO Revalidation
    postExternalDORevalidation(data: ExternalDoRevalidation) {
        let url = `${this.base_url}external_do_revalidation/`;
        return this.http.post(url, data);
    }

    getExternalDORevalidationbyReqID(ReqId): Observable<BackendListModel<ExternalDoRevalidation>> {
        let url = `${this.base_url}external_do_revalidation/${ReqId}`;
        return this.http.get<BackendListModel<ExternalDoRevalidation>>(url);
    }

    deleteExternalRevalidationbyid(revId: ExternalDoRevalidation) {
        let url = `${this.base_url}external_do_revalidation/${revId}`;
        return this.http.delete(url);
    }

    getAllContainersbyReturnId(RetId): Observable<BackendListModel<ContainerModel>> {
        let url = `${this.base_url1}container_number?return_id=${RetId}`;
        return this.http.get<BackendListModel<ContainerModel>>(url);
    }

    //getLocationbyRequestID
    getDepotLocationbyPickupreqID(id): Observable<BackendListModel<LocationModel>> {
        let url = `${this.base_url2}?pickup_request_id=${id}`;
        return this.http.get<BackendListModel<LocationModel>>(url);
    }

    //getStorageChargebyDepotID
    getStorageChargebyDepotID(DId, CId): Observable<BackendListModel<ManHourCharge>> {
        let url = `${this.base_url3}depotstoragecharges/?depot_id=${DId}&container_size_id=${CId}&o=-from_day`;
        return this.http.get<BackendListModel<ManHourCharge>>(url);
    }


    getDepotLocationbyReturnreqID(id): Observable<BackendListModel<LocationModel>> {
        let url = `${this.base_url2}?dropoff_request_id=${id}`;
        return this.http.get<BackendListModel<LocationModel>>(url);
    }

    //External DO Revalidation
    postExternalReturnRevalidation(data: ExternalDoRevalidation) {
        let url = `${this.base_url}external_return_revalidation/`;
        return this.http.post(url, data);
    }

    getExternalReturnRevalidationbyReqID(ReqId): Observable<BackendListModel<ExternalDoRevalidation>> {
        let url = `${this.base_url}external_return_revalidation/${ReqId}`;
        return this.http.get<BackendListModel<ExternalDoRevalidation>>(url);
    }

    deleteExternalRevalidationRObyid(revId: ExternalDoRevalidation) {
        let url = `${this.base_url}external_return_revalidation/${revId}`;
        return this.http.delete(url);
    }

    getDepotLocationbyRequestID(OId, RId, search = '',): Observable<BackendListModel<LocationModel>> {
        let url = `${this.base_url3}location_short?depot_owner_type=${OId}&pickup_request_id=${RId}`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('search', String(search));
        return this.http.get<BackendListModel<LocationModel>>(url);
    }

    getDepotLocationbyID(LId, search = '',): Observable<BackendListModel<LocationModel>> {
        let url = `${this.base_url3}location/${LId}`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('search', String(search));
        return this.http.get<BackendListModel<LocationModel>>(url);
    }

    getPickedUpContainers(requestId: string, containerSizeTypeId?: string, type?: string) {
        let url = '';
        url = `${this.base_url4}request_containers/${requestId}/?container_size_type_id=${containerSizeTypeId}&is_marked_in_return_reference=false` + (type == 'arcon' ? '&do_owner=' + type + '' : '');
        return this.http.get<ContainersList[]>(url);
    }

    deleteContactInfo(id: string) {
        let url = `${this.base_url}do_contact_details/${id}/`;
        return this.http.delete(url, {observe: 'response'});

    }

    deleteReturnContactInfo(id: string) {
        let url = `${this.base_url}return_contact_details/${id}/`;
        return this.http.delete(url, {observe: 'response'});
    }

    savePickupDetails(
        containers: any,
        pickup_date: any,
        remarks: string,
        selectDO: string,
        port:string,
        invoice_number:string,
        invoice_date:any
    ) {
        return this.http.post(this.save_pickup_url, {
            do_container_references: containers,
            pickup_date: pickup_date,
            remarks: remarks,
            do: selectDO,
            port:port,
            invoice_number:invoice_number,
            invoice_date:invoice_date
        });
    }

    getAllPickupDOContainers(reqID, doId, page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ContainerPickup>> {
        let url = `${this.base_url}do_container_reference/?request_id=${reqID}&do_id=${doId}`;
        let urlObj = new URL(url);
        // urlObj.searchParams.append('reqID', String(reqID));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('page', String(page));
        urlObj.searchParams.append('search', String(search));
        urlObj.searchParams.append('o', String(order));

        return this.http.get<BackendListModel<ContainerPickup>>(String(urlObj));
    }

    deleteContainerData(container_number, do_id: string) {
        let url = `${this.base_url}closed_do_container_delete/${do_id}/`;
        return this.http.put(url, {container_number: container_number});
    }

    getReleaseOrdersForMapping(supplyDo: string) {
        let url = '';
        url = `${this.base_url4}request_details/?use_requests_by_supply_do=${supplyDo}`;
        return this.http.get<any[]>(url);
    }
    //getPortsbyDepotId
    getPortsByLocationId(depot_id): Observable<BackendListModel<any>> {
        let url = `${this.base_url3}location/?depot_id=${depot_id}`;
        return this.http.get<BackendListModel<any>>(url);
    }

    swapContainer(data) {
        let url = `${this.base_url}swap_container/`;
        return this.http.post(url, data);
    }
}
